<template>
  <div class="checkout-section-inner">
    <form
      id="optional-note-form"
      @submit.prevent="saveDetails"
    >
      <div class="form-group">
        <label
          for="optional-note"
          class="control-label"
        >
          Please include any notes you wish to make on this order (optional)
        </label>
        <textarea
          id="note"
          v-model="note"
          rows="5"
          class="form-control"
        />
      </div>

      <button
        id="next"
        type="submit"
        class="btn btn-secondary"
      >
        <i class="fas fa-arrow-circle-right" />
        Next
      </button>
    </form>
  </div>
</template>
<script>
import { addNote } from "../../../shopfront/cartDataService";
export default {
  props: {
    cartPid: { type: String, required: true },
  },
  data() {
    return {
      note: '',
    };
  },
  methods: {
    saveDetails: function() {
      let vm = this;
      addNote(this.cartPid, this.$store.state.sellerPid, this.note, function() {
        vm.$emit('sectionComplete');
      });
    },
  },
};
</script>

